import { Component, OnInit } from '@angular/core';
import { EditSubOrganizationService, OrganizationStructureChild } from '../edit-sub-organization/edit-sub-organization.service';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router, ActivatedRoute } from '@angular/router';
import { OrganizationStateService } from '../../../shared/organization-state.service';

@Component({
  selector: 'app-show-sub-organization',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule],
  templateUrl: './show-sub-organization.component.html',
  styleUrl: './show-sub-organization.component.scss'
})
export class ShowSubOrganizationComponent implements OnInit {
  route: ActivatedRoute;
  router: Router;
  subOrganizations: OrganizationStructureChild[] = [];
  showSuccess = false;
  orgId: string = '';
  orgName: string = '';

  // Pagination
  pageSize = 5;
  currentPage = 1;
  get totalPages() {
    return Math.ceil(this.subOrganizations.length / this.pageSize);
  }
  get pagedSubOrganizations() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.subOrganizations.slice(start, start + this.pageSize);
  }

  constructor(
    router: Router,
    route: ActivatedRoute,
    private readonly editSubOrganizationService: EditSubOrganizationService,
    private readonly authService: AuthService,
    private readonly orgState: OrganizationStateService
  ) {
    this.router = router;
    this.route = route;
    this.route.queryParamMap.subscribe((params) => {
      if (params.get('updated') === '1') {
        this.showSuccess = true;
        // Reload sub-organization data to show updated values
        if (this.orgId) {
          this.fetchSubOrganizations();
        }
        setTimeout(() => {
          this.showSuccess = false;
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { updated: null },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
        }, 1500);
      }
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const orgId = params.get('orgId');
      if (orgId) {
        this.orgId = orgId;
        // Fetch org name from state/service
        this.orgState.orgResponse$.subscribe((org) => {
          this.orgName = org?.name || '';
        });
        this.fetchSubOrganizations();
      }
    });
  }

  fetchSubOrganizations() {
    const token = this.authService.token;
    this.editSubOrganizationService.getOrganizationStructure(this.orgId, token).subscribe({
      next: (data) => {
        this.subOrganizations = data.children || [];
        this.currentPage = 1;
      },
      error: (error) => {
        console.error('Failed to load sub-organizations:', error);
        this.subOrganizations = [];
      },
    });
  }

  onEditSubOrganization(subOrg: OrganizationStructureChild) {
    const parentOrgId = subOrg.parentOrgId || this.orgId;
    const subOrgId = subOrg.orgId;
    if (parentOrgId && subOrgId) {
      this.router.navigate(['/organization/edit-sub-organization', parentOrgId, subOrgId]);
    }
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
}
